export const COMPANY_NAME = "MMOCCUL ONLINE"
export const COMPANY_NAME_FULL = "MMOCCUL ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "MMOCCUL ONLINE"
export const META_DESCRIPTION = "Welcome to MMOCCUL ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://mmocculonline.com"
export const ENABLE_OTHER_DEPOSIT = false
